import React from 'react';

import { useValuesVisibility } from '../../hooks/useValuesVisibility';

type MaskProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export function Mask({ children, fallback = '••••' }: MaskProps) {
  const { valuesVisibility } = useValuesVisibility();

  if (valuesVisibility === 'hidden') {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
